import React from 'react';
import { Radio } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { formViewSelector } from '@store/policies/schedule/selectors';
import { setActivationState } from '@store/policies/schedule/actions';
import { formModes } from '@store/policies/schedule/formReducer';
import { actOptions } from '@store/policies/schedule/utils';
import { FieldWrapper, ActivationWrapper } from './styled';

function ActivationRadio() {
  const dispatch = useDispatch();
  const { mode, activationState } = useSelector(formViewSelector);

  const handleRadioChange = (e) => {
    dispatch(setActivationState(e.target.value));
  };

  const disabled = mode === formModes.delete;

  return (
    <FieldWrapper>
      <ActivationWrapper>
        <div>Policy Activation Time</div>
        <Radio.Group
          defaultValue={activationState}
          buttonStyle="solid"
          onChange={handleRadioChange}
          disabled={disabled}
        >
          <Radio.Button value={actOptions.now}>Activate Now</Radio.Button>
          <Radio.Button value={actOptions.schedule}>Schedule</Radio.Button>
        </Radio.Group>
      </ActivationWrapper>
    </FieldWrapper>
  );
}

export default React.memo(ActivationRadio);
